import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconArrowRightComponent } from "./med-icon-arrow-right.component";

@NgModule({
  declarations: [
    MedIconArrowRightComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconArrowRightComponent,
  ],
})
export class MedIconArrowRightModule { }
